export default class Model {
  constructor(_id, title, protocol, port) {
    // eslint-disable-next-line no-underscore-dangle
    this._id = _id
    this.title = title
    this.protocol = protocol
    this.port = port
  }
}
